import { http, HttpResponse } from 'msw';
import { PlessService } from '../../../app/shared/pless-service.model';
import { ResponseUtils } from '../response-utils';

export const kymw1705Handlers = [

  // 過去画像情報取得
  http.post(PlessService.SERVICE.getPastImageInfo.url, async ({ request }) => {
    const req = await request.json();
    return HttpResponse.json(getPastImageInfoResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 過去画像情報取得
  http.post(PlessService.SERVICE.registPastImage.url, async ({ request }) => {
    const req = await request.json();
    return ResponseUtils.getSuccess();
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),
];

const getPastImageInfoResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      'ImageFileName': 'P2662170C_05M.png',
      'ImagePreviewUrl': 'http://127.0.0.1:8083/N_PEACE/file/image/UnRegistImage.png',
      'ImageId': 'P2662170C_05M'
    }
  }
};
